import React from 'react';
import { connect } from '@cerebral/react';
import { state } from 'cerebral/tags';
import classNames from 'classnames';

import Modal from '../Modal';
import modalStyles from '../Modal.scss';
import styles from './AvatarModal.scss';
import { CdnContext } from '../../context';

class AvatarModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avatar: null,
        };
    }

    isAvatarChosen(a) {
        return this.state.avatar === a;
    }

    handleClick(a) {
        this.setState({
            avatar: a,
        });
    }

    handleSelect = () => {
        const { onAvatarChosen } = this.props;
        const { avatar } = this.state;

        if (avatar) {
            this.setState({ avatar: null });
            onAvatarChosen(avatar);
        }
    };

    render() {
        const { open, avatars, onClose } = this.props;

        if (!open) {
            return null;
        }

        return (
            <Modal onClose={onClose}>
                <div className={modalStyles.header}>
                    <h6 className={styles.heading}>
                        Welke avatar past het best bij de persoon die je wil
                        toevoegen?
                    </h6>
                </div>
                <div className={modalStyles.body}>
                    <div className={styles.avatars}>
                        {avatars.map(a => (
                            <CdnContext.Consumer>
                                {cdn => (
                                    <div
                                        key={a.slug}
                                        onClick={() => {
                                            this.handleClick(a);
                                        }}
                                        className={classNames(styles.avatar, {
                                            [styles.chosen]:
                                                this.isAvatarChosen(a),
                                        })}
                                    >
                                        <img
                                            src={`${cdn}assets/images/avatars/${
                                                a.filename
                                            }`}
                                            alt={a.slug}
                                        />
                                    </div>
                                )}
                            </CdnContext.Consumer>
                        ))}
                    </div>
                </div>
                <div className={modalStyles.footer}>
                    <button
                        className="btn btn-primary"
                        onClick={this.handleSelect}
                        disabled={!this.state.avatar}
                    >
                        + Toevoegen
                    </button>
                </div>
            </Modal>
        );
    }
}

const stateSignals = {
    avatars: state`app.data.avatars`,
};

export default connect(
    stateSignals,
    AvatarModal
);



// WEBPACK FOOTER //
// ./src/components/questions/AvatarModal.js